import { BASE_URL } from 'constants/api';
import { createPostAPI } from '@cuemath/rest-api';

const { usePost: useStudentOfferPost } = createPostAPI({
  getURL: (_, { studentId }) => `${BASE_URL}/students/${studentId}/student-offer/`,
});

export { useStudentOfferPost };
